export const DPSECURITY = "DPSECURITY";
